import ninjaApi from 'store/redux/apis/ninja.api';

export const ninjaAiApi = ninjaApi.injectEndpoints({
  tagTypes: ['AI'],
  overrideExisting: true,
  endpoints: (builder) => ({
    ninjAi: builder.query({
      query: (body) => ({
        url: '/ai/generate',
        method: 'POST',
        body,
      }),
      providesTags: ['AI'],
    }),
  }),
});

export const { useNinjAiQuery } = ninjaAiApi;
